import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/base/FaqAccordion';
import { faqs } from '@/mocks/faqs';

export default function FaqPreview() {
  return (
    <section className="bg-accent-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-primary-600">
            <span className="h-px w-6 bg-primary-400"></span>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            追瓜之前，你可能想先弄明白这些
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于时间线怎么整理、反转和后续瓜怎么区分、内容来源与更新节奏，这里都有说明。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看全部问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="lg:col-span-8">
          <FaqAccordion items={faqs.slice(0, 5)} />
        </div>
      </div>
    </section>
  );
}